// extracted by mini-css-extract-plugin
export default {"link":"Links_link__xKdOW","link-active":"Links_link-active__JIvP4"};